import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const PartnerService = {
  async getAllPartners(filters = {}) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Partner`, { params: filters });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
    return {
      status: 0,
      message: "Erreur de chargement des partenaires",
      data: [],
    };
  },

  async sendExcelFile(file) {
    try {
      const result = await axios.post(`${apiUrl}/Partner/Partner/import`, file);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
    return {
      status: 0,
      message: "Erreur lors de l'import du fichier",
    };
    },
    async getImportTemplateReferences() {
      try {
        const response = await axios.get(`${apiUrl}/Partner/Partner/templateReferences`);
        if (!response.data?.status) throw new Error(response.data?.message || 'Références indisponibles.');
        return response.data.data;
      } catch (error) {
        throw new Error(error.response?.data?.message || error.message || 'Références indisponibles.');
      }
    },
    async replaceImportFile(periodId, formData) {
      formData.set("period_id", periodId);
      try {
        const result = await axios.post(`${apiUrl}/Partner/Partner/replaceImport`, formData);
        return result?.data;
      } catch (error) {
        return error.response?.data || {
          status: 0,
          message: "Erreur lors du remplacement du fichier",
        };
      }
    },
    async getImportAnomalies(periodId) {
      try {
        const result = await axios.get(`${apiUrl}/Partner/Partner/stagingAnomalies/${periodId}`);
        return result?.data;
      } catch (error) {
        return error.response?.data || { status: 0, data: [], message: "Erreur de chargement des anomalies" };
      }
    },
    async getImportConflicts(periodId) {
      try {
        const result = await axios.get(`${apiUrl}/Partner/Partner/stagingConflicts/${periodId}`);
        return result?.data;
      } catch (error) {
        return error.response?.data || { status: 0, data: { conflicts: [] }, message: "Erreur de chargement des conflits" };
      }
    },
    async unsyncedPeriods() {
      try {
        const result = await axios.get(`${apiUrl}/Partner/Partner/unsyncedPeriods`);
        if (result) {
          return result.data;
        }
      } catch (error) {
        if (error.response) {
          return error.response.data;
        }
      }
      return {
        status: 0,
        message: "Erreur de chargement des périodes non synchronisées",
        data: [],
      };
    },
    async synchronizePeriods(periodIds) {
      try {
        const result = await axios.post(`${apiUrl}/Partner/Partner/synchronize`, {
          period_ids: periodIds,
        });
        if (result) {
          return result.data;
        }
      } catch (error) {
        if (error.response) {
          return error.response.data;
        }
      }
      return {
        status: 0,
        message: "Erreur lors de la synchronisation des fichiers",
        data: {
          synced: [],
          errors: [],
        },
      };
    },
    async previewPeriods(periodIds) {
      try {
        const result = await axios.post(`${apiUrl}/Partner/Partner/preview`, {
          period_ids: periodIds,
        });
        if (result) {
          return result.data;
        }
      } catch (error) {
        if (error.response) {
          return error.response.data;
        }
      }
      return {
        status: 0,
        message: "Erreur lors du chargement du contenu des fichiers",
        data: {
          previews: [],
          errors: [],
        },
      };
    },
    async resolveStaging(periodId, resolutions) {
      try {
        const result = await axios.post(`${apiUrl}/Partner/Partner/resolveStaging`, {
          period_id: periodId,
          resolutions,
        });
        if (result) {
          return result.data;
        }
      } catch (error) {
        if (error.response) {
          return error.response.data;
        }
      }
      return {
        status: 0,
        message: "Erreur lors de l'enregistrement des resolutions",
      };
    },
    async submitStaging(periodId) {
      try {
        const result = await axios.post(`${apiUrl}/Partner/Partner/submitStaging`, {
          period_id: periodId,
        });
        if (result) {
          return result.data;
        }
      } catch (error) {
        if (error.response) {
          return error.response.data;
        }
      }
      return {
        status: 0,
        message: "Erreur lors de la soumission du lot",
      };
    },
    async removePeriod(periodId, administrative = false) {
      try {
        const result = await axios.post(`${apiUrl}/Partner/Partner/remove`, {
          period_id: periodId,
          administrative,
        });
        if (result) {
          return result.data;
        }
      } catch (error) {
        if (error.response) {
          return error.response.data;
        }
      }
      return {
        status: 0,
        message: "Erreur lors du retrait de la periode",
        data: null,
      };
    },

    async getPeriods(filters = {}){
      try {
        const result = await axios.get(`${apiUrl}/Partner/Partner/periods`, { params: filters });
        if (result) {
          return result.data;
        }
      } catch (error) {
        if (error.response) {
          return error.response.data;
        }
      }
      return {
        status: 0,
        message: "Erreur de chargement des périodes",
        data: [],
      };
    },

    async getMyPeriods(filters = {}) {
      try {
        const result = await axios.get(`${apiUrl}/Partner/Partner/myPeriods`, { params: filters });
        if (result) {
          return result.data;
        }
      } catch (error) {
        if (error.response) {
          return error.response.data;
        }
      }
      return {
        status: 0,
        message: "Erreur de chargement de vos imports",
        data: [],
      };
    },

    async getPeriodFile(periodId, fileName = "base-partenaire.xlsx") {
      const response = await axios.get(`${apiUrl}/Partner/Partner/download/${periodId}`, {
        responseType: "blob",
      });
      return new File([response.data], fileName, { type: response.data?.type || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    },
    async downloadPeriod(periodId, fileName = "base-partenaire.xlsx") {
      const response = await axios.get(`${apiUrl}/Partner/Partner/download/${periodId}`, {
        responseType: "blob",
      });
      const url = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
};

export default PartnerService;
